import mqtt from 'mqtt/dist/mqtt.min'

const options = {
  username: 'admin', // 如有认证
  password: '123456',
  clean: true,
  KeepAlive: 60
}

let mqttClient = null

function connectMQTT() {
 if (mqttClient && mqttClient.connected) {
    console.log('MQTT 已连接，无需重复连接')
    return
  }
  // 192.168.110.82
  mqttClient = mqtt.connect('ws://localhost:8883/mqtt', options)

  mqttClient.on('connect', () => {
    console.log('MQTT 连接成功')
    mqttClient.subscribe('/service/game/status', { qos: 2 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    mqttClient.subscribe('/service/game/data', { qos: 0 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    // 精灵服务
    mqttClient.subscribe('/agent/sprit/feedback', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    mqttClient.subscribe('/service/camera/frame', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    // 更新服务
    mqttClient.subscribe('/service/upgrade/data', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    mqttClient.subscribe('/ja/eeg/status', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    mqttClient.subscribe('/service/eyetracker/status', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    // 脑电n170
    mqttClient.subscribe('/ja/eeg/n170', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    // 脑电蓝牙检索/连接回包
    mqttClient.subscribe('/ja/eeg/bt', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功 /ja/eeg/bt')
    })
    // 眼动数据
    mqttClient.subscribe('/service/eyetracker/gaze', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
    mqttClient.subscribe('/service/camera/frame', { qos: 1 }, (err) => {
      if (!err) console.log('订阅成功')
    })
  })

  mqttClient.on('error', (err) => {
    console.error('MQTT 发生错误:', err)
    mqttClient.end()
  })

  mqttClient.on('close', () => {
    console.log('MQTT 连接已关闭，将在一段时间后重连...')
  })
}

connectMQTT()

// 热更新/已连接时补订蓝牙主题
if (mqttClient && mqttClient.connected) {
  mqttClient.subscribe('/ja/eeg/bt', { qos: 1 })
}

export default mqttClient
